import { parseValue } from '@libs/utils/string'
import { decodeHtmlEntities } from '@libs/utils/utils'
const ALWAYS_PARSE = ['social-module']

export function parseCMSPlacementData(data) {
  const container = document.createElement('div')

  let safeContent = data.content.replace(
    /(:[\w-]+=")([\s\S]*?)("(?=\s*\/?>|\s+[a-zA-Z0-9:@#-]+(?:=|\s*\/?>)))/g,
    (match, start, innerContent, end) => {
      return start + innerContent.replace(/"/g, '&quot;') + end;
    }
  )

  safeContent = safeContent.replace(
    /(:[\w-]+="\{[\s\S]*?\}")/g,
    (match) => match.replace(/&#39;/g, "\\'")
  )

  container.innerHTML = safeContent

  const children = container.querySelectorAll('div[placement-id]')
  let placements = []

  children.forEach(child => {
    const firstChild = child.children[0]

    const placementChild = firstChild?.hasAttribute('data-vue')
      ? firstChild.children[0]
      : firstChild
 if (placementChild) {
      const name = placementChild.localName
      let templates = {}
      let props = {}

      Array.from(placementChild.children).forEach(template => {
        if (!template.attributes[0]) return
        const slotName = template.attributes[0].localName.replace('#', '')
        const html = template.innerHTML || template.content?.textContent || ''

    templates[slotName] =
      ALWAYS_PARSE.includes(name) || html.includes('<sgh-') ? parseMixedContent(html) : html
      })

      Array.from(placementChild.attributes).forEach(attribute => {
        props[attribute.localName.replace(':', '')] = parseValue(attribute.value)
      })

      placements.push({ name, templates, props })
    }
  })

  return placements
}

function parseMixedContent(htmlString) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html')
  const container = doc.body.firstChild

  return parseNodeRecursively(container)
}

function parseNodeRecursively(node) {
  const result = []

  Array.from(node.childNodes).forEach(child => {
    if (child.nodeType === Node.TEXT_NODE) {
      const text = child.textContent.trim()
      if (text) {
        result.push({ type: 'text', content: text })
      }
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      if (child.tagName.toLowerCase().includes('-')) {
        const component = {
          type: 'component',
          name: child.tagName.toLowerCase(),
          props: {},
          slots: {}
        }

        Array.from(child.attributes).forEach(attr => {
          let propName = attr.name
          let value = attr.value

          if (propName.includes(':') || propName.includes('-')) {
            propName = propName
              .replace(/^:/, '')
              .replace(/-([a-z])/g, (_, letter) => letter.toUpperCase())
          }

          if (value && (value.includes('{') || value.includes('['))) {
            try {
              const decoded = decodeHtmlEntities(value)
              component.props[propName] = new Function('return ' + decoded)()
            } catch {
              try {
                const json = decodeHtmlEntities(value)
                component.props[propName] = JSON.parse(json)
              } catch {
                component.props[propName] = value
              }
            }
          } else {
            if (value === 'true') component.props[propName] = true
            else if (value === 'false') component.props[propName] = false
            else if (value === propName) component.props[propName] = true
            else if (value !== '' && !isNaN(value)) component.props[propName] = Number(value)
            else component.props[propName] = value
          }
        })

        const templates = child.querySelectorAll(':scope > template')
        templates.forEach(tmpl => {
          const slotAttr = Array.from(tmpl.attributes).find(attr =>
            attr.name.startsWith('#') || attr.name.startsWith('v-slot')
          )
          const slotName = slotAttr ? slotAttr.name.replace('#', '').replace('v-slot:', '') : 'default'
          component.slots[slotName] = tmpl.innerHTML
        })

        const defaultContent = []
        Array.from(child.childNodes).forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent.trim()
            if (text) defaultContent.push(text)
          } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() !== 'template') {
            defaultContent.push(node.outerHTML)
          }
        })

        if (defaultContent.length > 0 && !component.slots.default) {
          component.slots.default = defaultContent.join(' ')
        }

        result.push(component)
      } else {
        const element = {
          type: 'element',
          tag: child.tagName.toLowerCase(),
          attrs: {},
          children: []
        }

        Array.from(child.attributes).forEach(attr => {
          element.attrs[attr.name] = attr.value
        })

        if (child.childNodes.length > 0) {
          element.children = parseNodeRecursively(child)
        }

        result.push(element)
      }
    }
  })

  return result
}
